<!-- 報告不要業者 基本情報タブ -->
<template>
  <div>
    <validation-observer ref="TraderBasicFormValidator">
      <v-card v-if="trader">
        <v-card-text>
            <!-- 規約の同意 -->
            <v-row
              v-if="!trader.id"
            >
              <v-col cols="12" md="6">
                <v-checkbox

                  v-model="trader.agreement"
                  dense
                  label="排出事業者同意の上、JWNETのWEB画面_表示項目設定の確認事項【産業廃棄物管理票の交付を要しない場合】を熟読した上で承諾をします。"
                  hide-details="auto"
                >
                </v-checkbox>

              </v-col>
            </v-row>
            <!-- /規約の同意 -->

            <!-- 加入区分 -->
            <v-row>
              <v-col cols="12" md="6">
                <v-radio-group
                  v-model="trader.subscriber_type"
                  :disabled="!!trader.id"
                  row
                  dense
                  hide-details="auto"
                  class="pa-0 ma-0"

                >
                  <v-radio
                    label="収集運搬業者"
                    value="transport_type"
                  />
                  <v-radio
                    label="処分業者"
                    value="disposer_type"

                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- /加入区分 -->

            <!-- 事業者コード -->
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="事業者コード"
                  rules="required|alpha_num_only|max:10"
                >
                  <v-text-field
                    v-model="trader.code"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="事業者コード"
                    outlined
                    persistent-placeholder
                    placeholder="例）N001"
                  >
                    <template v-slot:label>
                      <span>事業者コード</span>
                      <span class="ml-1">
                        ({{ trader.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                最近使用したコード:&nbsp;<strong>{{ trader.recent_registered_codes }}</strong>
              </v-col>
            </v-row>
            <!-- /コード -->

            <!-- 名称 -->
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="事業者名"
                  rules="required|max:60"
                >
                  <v-text-field
                    v-model="trader.name"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="事業者名"
                    outlined
                    persistent-placeholder
                    placeholder="例）○○○○　株式会社"
                  >
                    <template v-slot:label>
                      <span>事業者名</span>
                      <span class="ml-1">
                        ({{ trader.name?.length || 0 }} / 60)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>

              <v-col
                v-if="trader.subscriber_type === 'disposer_type'"
                cols="12"
                md="3"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="許可番号（下6桁）"
                  :rules="{ numeric: true, length: 6, is: '999999' }"
                >
                  <v-text-field
                    v-model="trader.permit_number"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    hint="999999を入力してください"
                    label="許可番号"
                    outlined
                    persistent-placeholder
                    placeholder=""
                  >
                    <template v-slot:label>
                      <span>許可番号</span>
                      <span class="ml-1">
                        ({{ trader.permit_number?.length || 0 }} / 6)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /名称 -->

            <!-- 郵便番号 -->
            <v-row>
              <v-col cols="12" md="5">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{zip_code: true, required: true, max:8 }"
                  class="requiredMark"
                  name="郵便番号"
                >
                  <v-text-field
                    v-model="trader.zip_code"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    hint="ハイフンを含めて入力してください"
                    label="郵便番号"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    placeholder="例）111-1111"
                    required
                  >
                    <template v-slot:label>
                      <span>郵便番号</span>
                      <span class="ml-1">
                        ({{ trader.zip_code?.length || 0 }} / 8)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                    <template v-slot:append-outer>
                      <zip-code-search
                        :zip-code="trader.zip_code"
                        @zipAddress="setTraderZipAddress"
                      />
                      &nbsp;
                      <v-btn
                        outlined
                        small
                        @click="searchZipButtonClickEvent"
                      >
                        住所→郵便番号
                      </v-btn>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /郵便番号 -->

            <!-- 都道府県／市区町村 -->
            <v-row>
              <v-col cols="12" md="3">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="都道府県"
                  class="requiredMark"
                >
                  <v-autocomplete
                    v-model="trader.prefecture_code"
                    :error-messages="errors"
                    :items="prefList"
                    dense
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    label="都道府県"
                    outlined
                    persistent-placeholder
                    placeholder="例）東京都"
                    required
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|full_width|max:20"
                  name="市区町村"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="trader.address_1"
                    :error-messages="errors"
                    dense
                    label="市区町村"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）中央区"
                    required
                  >
                    <template v-slot:label>
                      <span>市区町村</span>
                      <span class="ml-1">
                        ({{ trader.address_1?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /都道府県／市区町村 -->
            <!-- 町域 -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  name="町域"
                  rules="full_width|max:40"
                >
                  <v-text-field
                    v-model="trader.address_2"
                    :error-messages="errors"
                    dense
                    label="町域"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）日本橋兜町"
                  >
                    <template v-slot:label>
                      <span>町域</span>
                      <span class="ml-1">
                        ({{ trader.address_2?.length || 0 }} / 40)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /町域 -->
            <!-- 詳細住所 -->
            <v-row>
              <v-col md="9">
                <validation-provider
                  v-slot="{ errors }"
                  name="詳細住所"
                  rules="max:50"
                >
                  <v-text-field
                    v-model="trader.address_3"
                    :error-messages="errors"
                    dense
                    label="詳細住所"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）１−２−３　○○ビル○階"
                  >
                    <template v-slot:label>
                      <span>詳細住所</span>
                      <span class="ml-1">
                        ({{ trader.address_3?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /詳細住所 -->
            <!-- 電話番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="電話番号"
                  :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
                >
                  <v-text-field
                    v-model="trader.phone_number"
                    :error-messages="errors"
                    dense
                    label="電話番号"
                    hint="電話番号を「-」ハイフン「( )」込みで入力します"
                    persistent-hint
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）000-0000-0000"
                  >
                    <template v-slot:label>
                      <span>電話番号</span>
                      <span class="ml-1">
                        ({{ trader.phone_number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /電話番号 -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!trader.agreement && !trader.id"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <confirm ref="confirm" />
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="trader.prefecture_code"
      :initial-city-name="trader.address_1"
      :initial-town-name="trader.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Confirm from '../../../../../components/Confirm'
import PrefectureList from '../../../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../../../components/ZipCodeSearch'
import SearchZipModal from "../../../../components/SearchZipModal.vue";

export default {
  name: 'TraderBasicForm',
  components: {
    Confirm,
    ZipCodeSearch,
    SearchZipModal,
  },
  mixins: [ PrefectureList ],
  props: {},
  data () {
    return {
      trader: {
        id: null,
        name: null,
        zip_code: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        phone_number: null,
        permit_number: null,
      },
      /** ダイアログ用 */
      enableDetailDialog: false,
      enableSearchZipModal: false,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
  },
  watch: {
  },
  created() {
    if (this.$route.params.id) {
      this.editTrader({id: this.$route.params.id}).then((content) => {
        this.trader = content
        this.setMessage()
      })
    } else {
      this.newTrader().then((content) => {
        this.trader = content
      })
    }
  },
  methods: {
    ...mapActions('DriverMasterNonReportingTrader', {
      newTrader: 'new',
      editTrader: 'edit',
      createTrader: 'create',
      updateTrader: 'update',
      deleteTrader: 'destroy',
    }),
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTrader({id: this.trader.id }).then(() =>{
            this.$router.push({name: 'DriverMasterNonReportingTraders', params: { resetPagination: true }})
          })
        }
      })
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.TraderBasicFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      let params = {
        code: this.trader.code,
        name: this.trader.name,
        subscriber_type: this.trader.subscriber_type,
        zip_code: this.trader.zip_code,
        prefecture_code: this.trader.prefecture_code,
        address_1: this.trader.address_1,
        address_2: this.trader.address_2,
        address_3: this.trader.address_3,
        phone_number: this.trader.phone_number,
        permit_number: this.trader.permit_number,
      }

      if (this.$route.params.id) {
        this.updateTrader({ id: this.trader.id, params: params }).then(() => {
          this.$emit('callbackToParent')
        })
      } else {
        this.createTrader({ params: params }).then((content) => {
          // this.$router.push({ name: 'DriverMasterNonReportingTraders', params: { resetPagination: true } })
          if (content.id) {
            this.$router.push({name: 'DriverMasterNonReportingTraderEdit', params: {id: content.id}})
          }
        })
      }
    },
    cancelButtonClickEvent: function() {
      this.$router.push({ name: 'DriverMasterNonReportingTraders' })
    },
    setTraderZipAddress (content) {
      this.trader.prefecture_code = `${content.pref_code}`
      this.trader.address_1 = `${content.locality}`
      this.trader.address_2 = `${content.street}`
    },
    setMessage () {
    },
    showDialogButtonClickEvent () {
      this.enableDetailDialog = true
    },
    dialogCloseButtonCallback () {
      this.enableDetailDialog = false
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.trader.zip_code = address.zip_code
      this.trader.prefecture_code = `${address.prefecture_code}`
      this.trader.address_1 = address.city
      this.trader.address_2 = address.town
    },
    searchZipReflectZipCallback (zipCode) {
      this.trader.zip_code = zipCode;
    },
  },

}
</script>

<style scoped lang="scss">

</style>
